// @flow

import React from 'react'
import { useSelector } from 'react-redux'

function Logo () {
  const logoUrl = useSelector(state => state.account.user.logoUrl)

  return (
    <div id='logo'>
      <div style={{
        height: '37px',
        width: '118px',
        backgroundImage: `url(${logoUrl})`,
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        marginLeft: '41px'
      }} />
    </div>
  )
}

export default Logo
